import React, { useState, useEffect } from 'react';
import { FormError } from '@typings/common';

interface ErrorSummaryProps {
  errors: FormError[];
  duration?: number;
}

const ErrorSummary: React.FC<ErrorSummaryProps> = ({ errors, duration }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (duration && duration > 0) {
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, duration);

      return () => clearTimeout(timer);
    }
    return undefined;
  }, [duration]);

  if (!isVisible) return null; // If not visible, render nothing
  return (
    <div className="govuk-error-summary" data-module="govuk-error-summary">
      <div role="alert">
        <h2 className="govuk-error-summary__title">There is a problem</h2>
        <div className="govuk-error-summary__body">
          <ul className="govuk-list govuk-error-summary__list">
            {errors.map(error => {
              return (
                <li key={error.id}>
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a href="#">{error.message}</a>
                </li>
              );
            })}
          </ul>
          {errors.find(err => err.id === 'creadentialsNotMatch')?.message && (
            <p className="govuk-body">
              {
                errors.find(err => err.id === 'creadentialsNotMatch')
                  ?.extraMessage
              }
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

ErrorSummary.defaultProps = {
  duration: undefined,
};

export default ErrorSummary;
